module.exports = __webpack_public_path__ + "img/down-arrow.37891d8c.svg";